import { render, staticRenderFns } from "./PTIOriginal.vue?vue&type=template&id=490cb963&scoped=true"
import script from "./PTIOriginal.vue?vue&type=script&lang=js"
export * from "./PTIOriginal.vue?vue&type=script&lang=js"
import style0 from "./PTIOriginal.vue?vue&type=style&index=0&id=490cb963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cb963",
  null
  
)

export default component.exports